// BridgeCourse
import React from 'react';
import BridgeCourse from 'views/BridgeCourse';

const BridgeCoursePage = () => {
  return <BridgeCourse/>;
};

export default BridgeCoursePage;
